import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"leg-configuration"},_vm._l((_vm.filterCarriers()),function(carrier){return _c(VCol,{attrs:{"cols":"2"}},[_c(VCheckbox,{attrs:{"label":carrier.name,"value":carrier.id},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }